import { call } from 'redux-saga/effects'
import { CallApi } from '../api/callApi'
import { APIS } from '../../_config'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getTopCards(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.GET, APIS.EXECUTIVE_DASHBOARD.GET_TOP_CARDS, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch top cards',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getTopCards', action: action.type })
    }
}

export function* getPieChart(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.GET, APIS.EXECUTIVE_DASHBOARD.GET_PIE_CHART, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch pie chart data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getPieChart', action: action.type })
    }
}

export function* getExperimentFromTheMarket(action: any): Generator<any, void, any> {
    try {
        const { page, per_page, title, my_scope, sort_by } = action.payload
        const queryObject: any = {}
        if (page) queryObject['page'] = page
        if (per_page) queryObject['per_page'] = per_page
        if (title) queryObject['title'] = title
        if (my_scope !== undefined) queryObject['my_scope'] = my_scope
        if (sort_by) queryObject['sort_by'] = sort_by

        const APIURL = APIS.EXECUTIVE_DASHBOARD.GET_EXPERIMENT_FROM_THE_MARKET + `?${new URLSearchParams(queryObject).toString()}`

        const resp = yield call(CallApi.POST, APIURL, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch experiments from the market',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getExperimentFromTheMarket', action: action.type })
    }
}

export function* getDashboardTopLearnings(action: any): Generator<any, void, any> {
    try {
        const { page, per_page, alldata, my_scope, sort_by } = action.payload
        const queryObject: any = {}
        if (page) queryObject['page'] = page
        if (per_page) queryObject['per_page'] = per_page
        if (alldata) queryObject['alldata'] = alldata
        if (my_scope !== undefined) queryObject['my_scope'] = my_scope
        if (sort_by) queryObject['sort_by'] = sort_by

        const APIURL = APIS.EXECUTIVE_DASHBOARD.GET_TOP_LEARNINGS + `?${new URLSearchParams(queryObject).toString()}`

        const resp = yield call(CallApi.POST, APIURL, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dashboard top learnings',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getDashboardTopLearnings', action: action.type })
    }
}

export function* getExperimentSummaryOfOthers(action: any): Generator<any, void, any> {
    try {
        const { page, per_page, alldata, my_scope, sort_by } = action.payload
        const queryObject: any = {}
        if (page) queryObject['page'] = page
        if (per_page) queryObject['per_page'] = per_page
        if (alldata) queryObject['alldata'] = alldata
        if (my_scope !== undefined) queryObject['my_scope'] = my_scope
        if (sort_by) queryObject['sort_by'] = sort_by

        const APIURL = APIS.EXECUTIVE_DASHBOARD.GET_EXPERIMENT_FOR_ALL_USERS + `?${new URLSearchParams(queryObject).toString()}`

        const resp = yield call(CallApi.POST, APIURL, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch experiment summary of others',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getExperimentSummaryOfOthers', action: action.type })
    }
}

export function* getTopActiveUsers(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.GET, APIS.EXECUTIVE_DASHBOARD.GET_TOP_ACTIVE_USERS, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch top active users',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getTopActiveUsers', action: action.type })
    }
}

export function* getDashboardCards(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.POST, APIS.EXECUTIVE_DASHBOARD.DASHBOARD_CARDS, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dashboard cards',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getDashboardCards', action: action.type })
    }
}

export function* getDashboardFunnel(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.POST, APIS.EXECUTIVE_DASHBOARD.DASHBOARD_FUNNEL, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dashboard funnel',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getDashboardFunnel', action: action.type })
    }
}

export function* getDashboardFunnelExpList(action: any): Generator<any, void, any> {
    try {
        const { page, per_page, ...payload } = action.payload
        const queryObject: any = {}
        if (page) queryObject['page'] = page
        if (per_page) queryObject['per_page'] = per_page
        const APIURL = APIS.EXECUTIVE_DASHBOARD.DASHBOARD_FUNNEL_EXP_LIST + `?${new URLSearchParams(queryObject).toString()}`
        const resp = yield call(CallApi.POST, APIURL, payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dashboard funnel experiment list',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getDashboardFunnelExpList', action: action.type })
    }
}

export function* getDashboardBarChart(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.POST, APIS.EXECUTIVE_DASHBOARD.DASHBOARD_BAR_CHART, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dashboard bar chart',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getDashboardBarChart', action: action.type })
    }
}
